/**
 * Reclamation form logic - reclamation.latte
 */
$(document).ready(function () {

    if ($('#reclamation-prilohy-input').length === 0) return;

    new FileDropZone({
        dropZone:  '#reclamation-drop-zone',
        fileInput: '#reclamation-prilohy-input',
        fileList:  '#reclamation-file-list',
        allowedTypes: [
            'application/pdf',
            'image/jpeg', 'image/png', 'image/gif', 'image/webp',
            'video/mp4', 'video/quicktime', 'video/webm'
        ],
        allowedExtensions: ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'webp', 'mp4', 'mov', 'webm'],
        alertMessage: 'Některé soubory byly vynechány. Jsou povoleny pouze PDF, obrázky a videa.',
        maxFiles: 20
    });

});
